import { jsx as _jsx } from "react/jsx-runtime";
import { cva } from 'class-variance-authority';
import { Slot } from 'radix-ui';
import { cn } from "../../lib/utils.js";
const badgeVariants = cva('inline-flex w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-full border border-transparent px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap transition-[color,box-shadow] focus-visible:ring-[3px] focus-visible:ring-ring/40 [&>svg]:pointer-events-none [&>svg]:size-3.5', {
    variants: {
        variant: {
            default: 'bg-primary text-primary-foreground',
            secondary: 'bg-secondary text-secondary-foreground',
            outline: 'border-border text-foreground',
            highlight: 'bg-highlight-soft text-highlight-soft-foreground',
            success: 'bg-success-soft text-success-soft-foreground',
            warning: 'bg-warning-soft text-warning-soft-foreground',
            danger: 'bg-danger-soft text-danger-soft-foreground',
        },
    },
    defaultVariants: { variant: 'default' },
});
function Badge({ className, variant = 'default', asChild = false, ...props }) {
    const Comp = asChild ? Slot.Root : 'span';
    return (_jsx(Comp, { "data-slot": "badge", "data-variant": variant, className: cn(badgeVariants({ variant }), className), ...props }));
}
export { Badge, badgeVariants };
//# sourceMappingURL=badge.js.map